// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"54508577","154":"64c87088"}[chunkId] + ".chunk.js";
};